import { gql } from '@apollo/client';

export const getInformesAnteriores = gql`
  query informesAnterioresApi($type: String, $year: String, $month: String) {
    getInformes(type: $type, year: $year, month: $month)
      @rest(type: "[informesAnterioresModel]", path: "/gateway/webback/economicreports?{args}") {
      title
      type
      period
      detail
      fileKey
      startDate
      department
      status
      userCreate
    }
  }
`;
